var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row-center align-center br-5 min-w-44 min-h-40 ph-5",class:_vm.selectedClasses},[_vm._v("\n  "+_vm._s(_vm.pageNumber)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }